import React, {useCallback, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {Tooltip} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {FileUploadSharp} from "@mui/icons-material";
import Box from "@mui/material/Box";
import CutFileService from "../../../../API/cut-file/CutFileService";
import { getFileNameAndExtensionWithMaterial} from "../../../../utils/common/getFileExtension";
import {constantsErrorMessages} from "../../../../Constants";
import ModalAlert from "../customer-detales/ModalAlert";

const CutFileTable = ({cuttingMapId, nameMaterial}) => {
    const [alertData, setAlertData] = useState({});
    const [data, setData] = useState([
        {name: "SELCO", cutFileNameType: "SELCO"},
        {name: "SELCO (без заказа)", cutFileNameType: "SELCO_WITHOUT_ORDER"},
        {name: "HOLZMA", cutFileNameType: "HOLZMA"},
        {name: "KDT пильный центр", cutFileNameType: "KDT"},
        {name: "KDT ФРС", cutFileNameType: "KDT_PANEL_SAW"},
    ]);
    const getErrorResponseMessage = (error) => {
        const data = error?.response?.data;
        if (data instanceof ArrayBuffer) {
            try {
                return JSON.parse(new TextDecoder().decode(data))?.message;
            } catch (_) {
                return undefined;
            }
        }
        return data?.message;
    };
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success"
                ? message
                : getErrorResponseMessage(message) || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const downloadFile = useCallback(
        (row) => {
            CutFileService.downloadFile(cuttingMapId, row.original.cutFileNameType)
                .then(function (response) {
                    const name = getFileNameAndExtensionWithMaterial(response.headers['content-disposition'], nameMaterial);
                    const url = window.URL.createObjectURL(new Blob([response.data], {type: name}));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', name);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        },
        [],
    );

    const columns = useMemo(
        () => [
            {
                id: 'cutFileNameType',
                header: 'Тип',
                accessorKey: 'cutFileNameType',
                minSize: 70,
                sx: {
                    p: '0px 0px 0px 0px',
                    m: '0px',
                },
                Cell:
                    ({cell, row}) => row.original.name,
            },
        ],
        [data, setData],
    );

    return (
        <>
            <MaterialReactTable
                renderTopToolbar={({table}) => {
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                    }}>
                        <MRT_ToolbarAlertBanner table={table}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_ToggleFiltersButton table={table}/>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}
                selectAllMode={"all"}
                muiTableBodyCellProps={({cell, table}) => {
                    return ({
                        sx: () => ({
                            p: '0px 0px 0px 10px',
                            m: '0px 0px 0px 0px',
                            border: "none",
                            "&:after": {
                                display: "none",
                            },
                            "& td:after": {
                                "&:hover": {
                                    backgroundColor: "red"
                                }
                            },
                            "&:not(:last-of-type)": {
                                borderRight: '1px solid #EAEBEA',
                            },
                        })
                    })
                }}

                muiTableHeadCellProps={{
                    sx: {
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: "10px",
                        paddingBottom: " 0.2rem",
                        paddingTop: "0.2rem",
                        "&:first-of-type .Mui-TableHeadCell-Content-Wrapper": {
                            "minWidth": "100%"
                        }
                    },
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        sx: () => ({
                            height: '36px',
                            backgroundColor: "white",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            "&:hover": {
                                "& td:after": {
                                    display: "none",
                                },
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                            '&:nth-of-type(even)': {
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                            },
                        })
                    })
                }}

                columns={columns}
                data={data}
                enableEditing
                getRowId={(originalRow) => originalRow.id}
                renderRowActions={({row, table}) => (
                    <Box sx={{
                        display: 'flex',
                        gap: '0.1rem',
                        justifyContent: 'flex-start',
                        maxWidth: '5px'
                    }}>
                        <Tooltip arrow placement="left" title="Загрузить файл">
                            <IconButton color="success" onClick={() => downloadFile(row)}>
                                <FileUploadSharp/>
                            </IconButton>
                        </Tooltip>
                    </Box>
                )}
                initialState={{
                    columnVisibility: {
                        id: false,
                    },
                    isFullScreen: false,
                    density: "compact",
                    pagination: {pageIndex: 0, pageSize: 100},
                }}
                localization={MRT_Localization_RU}
            />
            <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
                return {...alert, open: false}
            })}/>
        </>

    );

};

export default CutFileTable;